import { type ReactElement } from 'react';
import { useStytchMemberSession } from '@stytch/react/b2b';
import { Navigate } from 'react-router';
import { Login } from './Login';

export const Authenticate = (): ReactElement => {
  const { session } = useStytchMemberSession();

  if (session) {
    return <Navigate to="/user-editor/users" />;
  }

  return <Login />;
};
